// Module
var code = "<div> <div class=\"name\">Application</div> <div v-if=\"editing\"> <dropdown-field :value.sync=\"filter.hasApplication\" :options=\"options\" label=\"Application\"> </dropdown-field> </div> <div v-if=\"!editing\">{{ friendly }}</div> </div> ";
// Exports
export default code;